module.exports = __webpack_public_path__ + "img/hik-axel-cam.2cac4646.png";